<div nz-flex [nzVertical]="true" class="p-10 mt-3">
  <nz-row nzGutter="24" class="rows displayFlex">
    <nz-col nzSpan="22">
      <div id="homeTable">
        <nz-table #basicTable [nzData]="listOfViewRawData" [nzFrontPagination]="false" [nzSize]="'small'"
          [nzBordered]="'true'" class="nz-table">
          <thead>
            <tr>
              <th>{{ headerData.scheduleLabor }}</th>
              <th>{{ headerData.reportInfo }}</th>
              <th>{{ headerData.search }}</th>
            </tr>
          </thead>
          <tbody>
            @for (data of basicTable.data; track data) {
            <tr>
              <td>
                <a [routerLink]="[data.scheduleComponentPath]" [ngClass]="{ disabled: data.scheduleDisabled }">{{
                  data.schedules }}</a>
              </td>
              <td>
                <a [routerLink]="[data.reportComponentPath]" [ngClass]="{ disabled: data.reportsDisabled }">{{
                  data.reports }}</a>
              </td>
              <td>
                <a [routerLink]="[data.searchComponentPath]" [ngClass]="{ disabled: data.searchDisabled }">{{
                  data.search }}</a>
              </td>
            </tr>
            }
          </tbody>
        </nz-table>
      </div>
      <div nz-row class="text-primary text-right pr-1 pb-3">
        <div nz-col nzSpan="24">
          <a href="https://chevron.service-now.com/mychevron?id=ec_pro_dashboard_my_chevron" target="_blank">{{
            application.itContactSupportTeam }}</a>
        </div>
      </div>
    </nz-col>
  </nz-row>
</div>